// Remittance State

export default {
  remittanceOfficeList: [],
  remittanceOfficeInfo: {},
  fullRemittanceList: []
}
